// src/redux/actions/logActions.js
export const fetchLogs = ({ startDate, endDate, userId, requestType, responseType, page }) => async (dispatch) => {
  try {
    const query = new URLSearchParams({
      startDate,
      endDate,
      userId,
      requestType,
      responseType,
      page,
    }).toString();
    const response = await fetch(`/api/logs?${query}`);
    if (response.ok) {
      const data = await response.json();
      dispatch({ type: 'FETCH_LOGS_SUCCESS', payload: data });
    }
  } catch (error) {
    // Handle error
  }
};
